import { Badge, UncontrolledTooltip } from 'reactstrap';
import styled from 'styled-components';
import IconButton from '../basics/IconButton';
import SectionsIcon from '../icons/SectionsIcon';
import LockIcon from '../icons/LockIcon';

const FarmIcon = styled(SectionsIcon)`
  width: 25px;
  height: 25px;
  color: var(--overyield-blue);
`;

const BigIconButton = styled(IconButton)`
  padding: 12px 16px;
`;

const LockedBadge = styled(
  ({ className, lockedBadgeInfo = 'Click to upgrade' }) => (
    <>
      <Badge
        color="warning"
        className={`${className} text-muted font-weight-normal font-tiny`}
        id="locked-badge"
      >
        <LockIcon /> Locked
      </Badge>
      <UncontrolledTooltip
        placement="bottom"
        target="locked-badge"
        innerClassName="font-tiny"
      >
        {lockedBadgeInfo}
      </UncontrolledTooltip>
    </>
  ),
)`
  svg {
    width: 7px;
    position: relative;
    top: -1px;
  }
`;

const NewFarmButton = ({
  showLockedBadge,
  lockedBadgeInfo,
  onClick,
  ...buttonProps
}) => {
  const { className: buttonClassName } = buttonProps;
  return (
    <BigIconButton
      onClick={onClick}
      outline
      {...buttonProps}
      className={`${buttonClassName} d-none d-md-flex`}
    >
      <div className="d-flex align-items-center font-small">
        <FarmIcon />
        <div className="ml-2 text-left">
          <div className="font-small font-weight-bold">New Farm</div>
          <div className="font-tiny">Design and plan</div>
        </div>
      </div>
      <div className="ml-3">
        {showLockedBadge ? (
          <LockedBadge lockedBadgeInfo={lockedBadgeInfo} />
        ) : (
          <div>+</div>
        )}
      </div>
    </BigIconButton>
  );
};

export default NewFarmButton;
